import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	smartFieldsReadMore: {
		id: 'issue-create.modal.create-form.layout-renderer.fields-container.smart-fields-read-more',
		defaultMessage:
			'Fields you don’t use often are automatically listed here. <link>Read more about the fields available when creating issues</link>',
		description:
			'Message shown in smart fields feature to explain why the user is seem the fields there with link to read more about the feature.',
	},
});
